import { createI18n } from 'vue-i18n'
import ro from './ro.json'
import en from './en.json'

export default (language) =>
  createI18n({
    legacy: false,
    locale: language,
    fallbackLocale: 'ro',
    messages: { ro, en },
  })
